export default "__VITE_ASSET__CsA_RX57__"